module.exports = __webpack_public_path__ + "8c991efd.svg";